import { useApolloClient } from '@apollo/client';
import { Queries } from 'apollo';
import useAuthContext from 'hooks/useAuthContext';

const useGetW4Url = () => {
  const context = useAuthContext();
  const client = useApolloClient();
  return ({ documentId }) =>
    client
      .query({
        query: Queries.getMyW4DocumentUrl,
        variables: { documentId },
        context,
        fetchPolicy: 'no-cache',
      })
      .then(response => {
        return response.data.getCurrentUser.w4DocumentUrl;
      });
};

export default useGetW4Url;
